import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { State } from '../../typings/state';
import { TDispatchProps, TStateProps } from '../../typings/utils';

import { closeItemNameEditor, ItemNameEditorAction, openItemNameEditor, updateItemNameEditorValue } from './actions';
import { CanvasEditableLabel, CanvasEditableLabelProps } from './CanvasEditableLabel';
import { selectItemNameEditorValue } from './selectors';

export interface CanvasEditableLabelOwnProps {
    editBtnCls?: string;
    editInputCls?: string;
    savedValue: string;
    editorId: string;
    hasClear?: boolean;
    enableEmptyInput?: boolean;
    withControls?: boolean;
    onValueSaved: (newValue: string) => void;
    iconRight?: React.ReactElement<{}>;
    cls?: string;
}

export type CanvasEditableLabelStateProps = TStateProps<CanvasEditableLabelProps, CanvasEditableLabelOwnProps>;
export type CanvasEditableLabelDispatchProps = TDispatchProps<CanvasEditableLabelProps, CanvasEditableLabelOwnProps>;

const mapStateToProps = (state: State, ownProps: CanvasEditableLabelOwnProps): CanvasEditableLabelStateProps => {
    const { itemNameEditors } = state.canvasEditor;
    const { value, isVisible } = selectItemNameEditorValue(itemNameEditors, ownProps.editorId);

    return {
        value: isVisible ? value : ownProps.savedValue,
        isEditMode: isVisible
    };
};

const mapDispatchToProps = (
    dispatch: Dispatch<ItemNameEditorAction>,
    ownProps: CanvasEditableLabelOwnProps
): CanvasEditableLabelDispatchProps => {
    const { editorId, onValueSaved } = ownProps;

    return {
        onChange: (name: string) => {
            dispatch(updateItemNameEditorValue(editorId, name));
        },
        onOpenEditor: (name: string) => {
            dispatch(openItemNameEditor(editorId, name));
        },
        onCancel: () => {
            dispatch(closeItemNameEditor(editorId));
        },
        onSave: (name: string) => {
            dispatch(closeItemNameEditor(editorId));
            onValueSaved(name);
        }
    };
};

const mergeProps = (
    stateProps: CanvasEditableLabelStateProps,
    dispatchProps: CanvasEditableLabelDispatchProps,
    ownProps: CanvasEditableLabelOwnProps
): CanvasEditableLabelProps => {
    const { savedValue, editorId, onValueSaved, ...restOwnProps } = ownProps;

    return {
        ...stateProps,
        ...dispatchProps,
        ...restOwnProps
    };
};

export const CanvasEditableLabelContainer = connect<
    CanvasEditableLabelStateProps,
    CanvasEditableLabelDispatchProps,
    CanvasEditableLabelOwnProps,
    CanvasEditableLabelProps
>(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
)(CanvasEditableLabel);
